import type { CrmTranslate } from './crm-copy';

export function createCrmPortalCopy(t: CrmTranslate) {
  return {
    portalConnectionsPage: {
      documentTitle: t('crm.portalConnectionsPage.documentTitle'),
      title: t('crm.portalConnectionsPage.title'),
      counts: {
        connections: (count: number) =>
          t('crm.portalConnectionsPage.counts.connections', {
            values: { count },
          }),
      },
      actions: {
        grid: t('crm.portalConnectionsPage.actions.grid'),
        list: t('crm.portalConnectionsPage.actions.list'),
        addPortal: t('crm.portalConnectionsPage.actions.addPortal'),
        clearSearch: t('crm.portalConnectionsPage.actions.clearSearch'),
        edit: t('crm.portalConnectionsPage.actions.edit'),
        healthCheck: t('crm.portalConnectionsPage.actions.healthCheck'),
        checking: t('crm.portalConnectionsPage.actions.checking'),
        disable: t('crm.portalConnectionsPage.actions.disable'),
        cancel: t('crm.portalConnectionsPage.actions.cancel'),
        confirm: t('crm.portalConnectionsPage.actions.confirm'),
        saving: t('crm.portalConnectionsPage.actions.saving'),
        saveChanges: t('crm.portalConnectionsPage.actions.saveChanges'),
        createPortal: t('crm.portalConnectionsPage.actions.createPortal'),
        runHealthCheck: t('crm.portalConnectionsPage.actions.runHealthCheck'),
      },
      search: {
        placeholder: t('crm.portalConnectionsPage.search.placeholder'),
      },
      sort: {
        label: t('crm.portalConnectionsPage.sort.label'),
        created: t('crm.portalConnectionsPage.sort.created'),
        account: t('crm.portalConnectionsPage.sort.account'),
        portalKey: t('crm.portalConnectionsPage.sort.portalKey'),
        status: t('crm.portalConnectionsPage.sort.status'),
        healthCheck: t('crm.portalConnectionsPage.sort.healthCheck'),
        sortOrderTitle: (direction: string) =>
          t('crm.portalConnectionsPage.sort.sortOrderTitle', {
            values: { direction },
          }),
        ascending: t('crm.portalConnectionsPage.sort.ascending'),
        descending: t('crm.portalConnectionsPage.sort.descending'),
      },
      pageSize: {
        show: t('crm.portalConnectionsPage.pageSize.show'),
        perPage: t('crm.portalConnectionsPage.pageSize.perPage'),
      },
      empty: {
        errorTitle: t('crm.portalConnectionsPage.empty.errorTitle'),
        loadingTitle: t('crm.portalConnectionsPage.empty.loadingTitle'),
        loadingDescription: t('crm.portalConnectionsPage.empty.loadingDescription'),
        noConnectionsTitle: t('crm.portalConnectionsPage.empty.noConnectionsTitle'),
        searchDescription: t('crm.portalConnectionsPage.empty.searchDescription'),
        startDescription: t('crm.portalConnectionsPage.empty.startDescription'),
      },
      details: {
        regionNotSet: t('crm.portalConnectionsPage.details.regionNotSet'),
        healthChecked: t('crm.portalConnectionsPage.details.healthChecked'),
        notCheckedYet: t('crm.portalConnectionsPage.details.notCheckedYet'),
      },
      pagination: {
        entityLabel: t('crm.portalConnectionsPage.pagination.entityLabel'),
      },
      titles: {
        edit: t('crm.portalConnectionsPage.titles.edit'),
        create: t('crm.portalConnectionsPage.titles.create'),
      },
      labels: {
        portalKey: t('crm.portalConnectionsPage.labels.portalKey'),
        accountName: t('crm.portalConnectionsPage.labels.accountName'),
        connectorType: t('crm.portalConnectionsPage.labels.connectorType'),
        status: t('crm.portalConnectionsPage.labels.status'),
        authType: t('crm.portalConnectionsPage.labels.authType'),
        credentialsReference: t('crm.portalConnectionsPage.labels.credentialsReference'),
        marketRegion: t('crm.portalConnectionsPage.labels.marketRegion'),
        baseUrl: t('crm.portalConnectionsPage.labels.baseUrl'),
      },
      options: {
        generic: t('crm.portalConnectionsPage.options.generic'),
        http: t('crm.portalConnectionsPage.options.http'),
        active: t('crm.portalConnectionsPage.options.active'),
        disabled: t('crm.portalConnectionsPage.options.disabled'),
        error: t('crm.portalConnectionsPage.options.error'),
      },
      health: {
        title: t('crm.portalConnectionsPage.health.title'),
        lastHealthCheck: t('crm.portalConnectionsPage.health.lastHealthCheck'),
        never: t('crm.portalConnectionsPage.health.never'),
        noErrors: t('crm.portalConnectionsPage.health.noErrors'),
      },
      confirmations: {
        disableTitle: t('crm.portalConnectionsPage.confirmations.disableTitle'),
        disableMessage: (name: string) =>
          t('crm.portalConnectionsPage.confirmations.disableMessage', {
            values: { name },
          }),
      },
      messages: {
        loadFailed: t('crm.portalConnectionsPage.messages.loadFailed'),
        saveFailed: t('crm.portalConnectionsPage.messages.saveFailed'),
        created: t('crm.portalConnectionsPage.messages.created'),
        updated: t('crm.portalConnectionsPage.messages.updated'),
        healthCheckFailed: t('crm.portalConnectionsPage.messages.healthCheckFailed'),
        healthCheckCompleted: t('crm.portalConnectionsPage.messages.healthCheckCompleted'),
        disableFailed: t('crm.portalConnectionsPage.messages.disableFailed'),
        disabled: t('crm.portalConnectionsPage.messages.disabled'),
      },
    },
    portalLeadsPage: {
      documentTitle: t('crm.portalLeadsPage.documentTitle'),
      title: t('crm.portalLeadsPage.title'),
      counts: {
        leads: (count: number) =>
          t('crm.portalLeadsPage.counts.leads', {
            values: { count },
          }),
      },
      actions: {
        grid: t('crm.portalLeadsPage.actions.grid'),
        list: t('crm.portalLeadsPage.actions.list'),
        routingRules: t('crm.portalLeadsPage.actions.routingRules'),
        clearSearch: t('crm.portalLeadsPage.actions.clearSearch'),
        advancedFilters: t('crm.portalLeadsPage.actions.advancedFilters'),
        createContact: t('crm.portalLeadsPage.actions.createContact'),
        contactLinked: t('crm.portalLeadsPage.actions.contactLinked'),
        createDeal: t('crm.portalLeadsPage.actions.createDeal'),
        dealCreated: t('crm.portalLeadsPage.actions.dealCreated'),
        working: t('crm.portalLeadsPage.actions.working'),
        conversation: t('crm.portalLeadsPage.actions.conversation'),
      },
      search: {
        placeholder: t('crm.portalLeadsPage.search.placeholder'),
      },
      sort: {
        label: t('crm.portalLeadsPage.sort.label'),
        received: t('crm.portalLeadsPage.sort.received'),
        leadName: t('crm.portalLeadsPage.sort.leadName'),
        portal: t('crm.portalLeadsPage.sort.portal'),
        status: t('crm.portalLeadsPage.sort.status'),
        sortOrderTitle: (direction: string) =>
          t('crm.portalLeadsPage.sort.sortOrderTitle', {
            values: { direction },
          }),
        ascending: t('crm.portalLeadsPage.sort.ascending'),
        descending: t('crm.portalLeadsPage.sort.descending'),
      },
      pageSize: {
        show: t('crm.portalLeadsPage.pageSize.show'),
        perPage: t('crm.portalLeadsPage.pageSize.perPage'),
      },
      empty: {
        errorTitle: t('crm.portalLeadsPage.empty.errorTitle'),
        loadingTitle: t('crm.portalLeadsPage.empty.loadingTitle'),
        loadingDescription: t('crm.portalLeadsPage.empty.loadingDescription'),
        noLeadsTitle: t('crm.portalLeadsPage.empty.noLeadsTitle'),
        searchDescription: t('crm.portalLeadsPage.empty.searchDescription'),
        startDescription: t('crm.portalLeadsPage.empty.startDescription'),
      },
      filters: {
        title: t('crm.portalLeadsPage.filters.title'),
        closeTitle: t('crm.portalLeadsPage.filters.closeTitle'),
        portalLabel: t('crm.portalLeadsPage.filters.portalLabel'),
        allPortals: t('crm.portalLeadsPage.filters.allPortals'),
        ingestionStatusLabel: t('crm.portalLeadsPage.filters.ingestionStatusLabel'),
        allStatuses: t('crm.portalLeadsPage.filters.allStatuses'),
        clearAll: t('crm.portalLeadsPage.filters.clearAll'),
        applyFilters: t('crm.portalLeadsPage.filters.applyFilters'),
      },
      filterOptions: {
        portals: {
          bayut: t('crm.portalLeadsPage.filterOptions.portals.bayut'),
          property_finder: t('crm.portalLeadsPage.filterOptions.portals.propertyFinder'),
          dubizzle: t('crm.portalLeadsPage.filterOptions.portals.dubizzle'),
          generic_http: t('crm.portalLeadsPage.filterOptions.portals.genericHttp'),
        },
        statuses: {
          received: t('crm.portalLeadsPage.filterOptions.statuses.received'),
          normalized: t('crm.portalLeadsPage.filterOptions.statuses.normalized'),
          matched: t('crm.portalLeadsPage.filterOptions.statuses.matched'),
          created: t('crm.portalLeadsPage.filterOptions.statuses.created'),
          failed: t('crm.portalLeadsPage.filterOptions.statuses.failed'),
        },
      },
      details: {
        inquiryType: (portal: string, inquiryType: string) =>
          t('crm.portalLeadsPage.details.inquiryType', {
            values: { portal, inquiryType },
          }),
        linkedEntities: (contact: string, deal: string) =>
          t('crm.portalLeadsPage.details.linkedEntities', {
            values: { contact, deal },
          }),
      },
      fallbacks: {
        generalInquiry: t('crm.portalLeadsPage.fallbacks.generalInquiry'),
        noPhoneOrExternalLeadId: t('crm.portalLeadsPage.fallbacks.noPhoneOrExternalLeadId'),
        noMessageBody: t('crm.portalLeadsPage.fallbacks.noMessageBody'),
        contactNotLinked: t('crm.portalLeadsPage.fallbacks.contactNotLinked'),
        dealNotCreated: t('crm.portalLeadsPage.fallbacks.dealNotCreated'),
        unnamedLead: t('crm.portalLeadsPage.fallbacks.unnamedLead'),
        noEmailSupplied: t('crm.portalLeadsPage.fallbacks.noEmailSupplied'),
        portalLead: t('crm.portalLeadsPage.fallbacks.portalLead'),
      },
      conversation: {
        title: t('crm.portalLeadsPage.conversation.title'),
        subject: (lead: string) =>
          t('crm.portalLeadsPage.conversation.subject', {
            values: { lead },
          }),
        emptyDescription: t('crm.portalLeadsPage.conversation.emptyDescription'),
      },
      pagination: {
        entityLabel: t('crm.portalLeadsPage.pagination.entityLabel'),
      },
      messages: {
        loadFailed: t('crm.portalLeadsPage.messages.loadFailed'),
        createContactFailed: t('crm.portalLeadsPage.messages.createContactFailed'),
        contactCreated: t('crm.portalLeadsPage.messages.contactCreated'),
        createDealFailed: t('crm.portalLeadsPage.messages.createDealFailed'),
        dealCreated: t('crm.portalLeadsPage.messages.dealCreated'),
      },
    },
    leadRoutingManager: {
      title: t('crm.leadRoutingManager.title'),
      actions: {
        close: t('crm.leadRoutingManager.actions.close'),
        createRule: t('crm.leadRoutingManager.actions.createRule'),
        saveRule: t('crm.leadRoutingManager.actions.saveRule'),
        saving: t('crm.leadRoutingManager.actions.saving'),
        newRule: t('crm.leadRoutingManager.actions.newRule'),
      },
      states: {
        loading: t('crm.leadRoutingManager.states.loading'),
        empty: t('crm.leadRoutingManager.states.empty'),
      },
      labels: {
        ruleName: t('crm.leadRoutingManager.labels.ruleName'),
        portalKey: t('crm.leadRoutingManager.labels.portalKey'),
        assignedAgentId: t('crm.leadRoutingManager.labels.assignedAgentId'),
        fallbackOwnerId: t('crm.leadRoutingManager.labels.fallbackOwnerId'),
        taskTitle: t('crm.leadRoutingManager.labels.taskTitle'),
        autoCreateTask: t('crm.leadRoutingManager.labels.autoCreateTask'),
        ruleActive: t('crm.leadRoutingManager.labels.ruleActive'),
      },
      placeholders: {
        leaveBlankForDefault: t('crm.leadRoutingManager.placeholders.leaveBlankForDefault'),
        followUpWithLead: t('crm.leadRoutingManager.placeholders.followUpWithLead'),
      },
      fallbacks: {
        defaultRule: t('crm.leadRoutingManager.fallbacks.defaultRule'),
      },
      statuses: {
        active: t('crm.leadRoutingManager.statuses.active'),
        paused: t('crm.leadRoutingManager.statuses.paused'),
        taskEnabled: t('crm.leadRoutingManager.statuses.taskEnabled'),
        noTask: t('crm.leadRoutingManager.statuses.noTask'),
      },
      messages: {
        loadFailed: t('crm.leadRoutingManager.messages.loadFailed'),
        saveFailed: t('crm.leadRoutingManager.messages.saveFailed'),
      },
    },
  };
}
